// extracted by mini-css-extract-plugin
export default {"comments":"style_comments__AFWeb","container":"style_container__fdmYZ"};